import { useBrand } from "../theme/ThemeProvider";
import { BrandLogo } from "../theme/BrandLogo";
import { logout } from "../lib/api";
import type { SignupStatus } from "../lib/api";

interface PendingProps {
  status: SignupStatus | null;
}

// Gate page rendered for authenticated-but-not-provisioned users.
// Reuses the SignIn ``.signin*`` shell so the whole pre-dashboard
// experience (sign-in landing → queue → declined) reads as one
// coherent series of screens. Differentiates pending vs rejected
// in copy only — semantic decision colours (--risk-*) are reserved
// for the screening band per the design system.
export function Pending({ status }: PendingProps) {
  const brand = useBrand();
  const rejected = status === "rejected";

  return (
    <div className="center signin">
      <div className="signin-card">
        <div className="signin-mark">
          <BrandLogo alt="" />
        </div>
        <span className="eyebrow">Private preview</span>
        <h1 className="signin-title">
          {rejected ? "Access declined" : "You're on the list"}
        </h1>
        <p className="signin-tagline">
          {rejected
            ? `We weren't able to approve your access to ${brand.productName} at this time.`
            : `${brand.productName} is in a private preview. Your request is awaiting review — we'll be in touch as soon as your account is ready.`}
        </p>

        <div className="signin-actions">
          <button
            type="button"
            className="btn secondary signin-cta"
            onClick={() => logout().then(() => location.reload())}
          >
            Sign out
          </button>
        </div>

        <p className="signin-fineprint">
          {rejected ? "Questions?" : "Need help?"}{" "}
          <a href={`mailto:${brand.supportEmail}`}>{brand.supportEmail}</a>
        </p>
      </div>
    </div>
  );
}
